
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/premiya-tec",
      function () {
        return require("private-next-pages/events/premiya-tec.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/premiya-tec"])
      });
    }
  